import request from '@/utils/request'


// 查询调查问卷选项列表
export function listSurvey(query) {
  return request({
    url: '/biz/survey/list',
    method: 'get',
    params: query
  })
}

// 查询调查问卷选项分页
export function pageSurvey(query) {
  return request({
    url: '/biz/survey/page',
    method: 'get',
    params: query
  })
}

// 查询调查问卷选项详细
export function getSurvey(data) {
  return request({
    url: '/biz/survey/detail',
    method: 'get',
    params: data
  })
}

// 新增调查问卷选项
export function addSurvey(data) {
  return request({
    url: '/biz/survey/add',
    method: 'post',
    data: data
  })
}

// 修改调查问卷选项
export function updateSurvey(data) {
  return request({
    url: '/biz/survey/edit',
    method: 'post',
    data: data
  })
}

// 删除调查问卷选项
export function delSurvey(data) {
  return request({
    url: '/biz/survey/delete',
    method: 'post',
    data: data
  })
}
